import * as React from 'react'
import { History, Location } from 'history'
import {
  countActiveFilters,
  GalleryFilters,
  parseGalleryFilters,
  serializeGalleryFilters,
} from './galleryFilterParams'

interface UseGalleryFiltersResult {
  filters: GalleryFilters
  activeCount: number
  apply: (next: GalleryFilters) => void
  clearAll: () => void
}

export const useGalleryFilters = (
  location: Location,
  history: History
): UseGalleryFiltersResult => {
  const filters = React.useMemo(() => parseGalleryFilters(location.search), [location.search])

  const apply = React.useCallback(
    (next: GalleryFilters) => {
      const search = serializeGalleryFilters(next, location.search)
      history.push({ pathname: location.pathname, search: search ? `?${search}` : '' })
    },
    [history, location.pathname, location.search]
  )

  const clearAll = React.useCallback(() => apply({}), [apply])

  return {
    filters,
    activeCount: countActiveFilters(filters),
    apply,
    clearAll,
  }
}
